import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  Input {
    border: 0.07rem solid #a9aeb4;
    width: 16.8rem;
    height: 2.7rem;
    color: #111;
    font-size: 0.81rem;
    border-radius: 0.4rem;
    font-weight: 400;
    padding: 0rem 1rem;
  }

  Button {
    width: 18.8rem;
    height: 2.7rem;

    background: #585e66;
    color: #eff1f5;
    font-size: 0.81rem;
    border-radius: 0.4rem;
    text-align: center;
    font-weight: 600;

    margin-top: 2rem;
  }
`;

export const BoxForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 7.5rem;
  height: 100vh;
  background-color: #eff1f5;
`;

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img`
  width: 2.38rem; //50.85px;
  z-index: 5;
  margin-bottom: 2rem;
`;

export const Title = styled.span`
  color: #42464c;
  font-size: 1.61rem;
  font-weight: 600;
  line-height: 1.21rem;
  margin-bottom: 4rem;
`;
export const Label = styled.span`
  color: #585e66;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  margin-top: 1rem;
`;

export const Checkers = styled.span`
  color: ${(props) => (props.check ? "#7e858f" : "#ea6868")};
  font-size: 0.8rem;
  line-height: 0.8333rem;
  padding: 0.5rem 0rem 0rem 0rem;
  width: 16.8rem;
`;
